import { render, staticRenderFns } from "./addZigongsi.vue?vue&type=template&id=220dfd2e&scoped=true"
import script from "./addZigongsi.vue?vue&type=script&lang=js"
export * from "./addZigongsi.vue?vue&type=script&lang=js"
import style0 from "./addZigongsi.vue?vue&type=style&index=0&id=220dfd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dfd2e",
  null
  
)

export default component.exports